import React from "react";
import "./UserAgreement.css";

const UserAgreement = () => {
  return (
    <div>
      <div id="user-agreement">
        <div className="container">
          <div className="section-title">
            <h1>Пользовательское соглашение программного обеспечения «Цифровой двойник сети Hadal»</h1>
          </div>
          
          <div className="agreement-content">
            <section>
              <p>
                Настоящее Пользовательское соглашение (далее – Соглашение) относится к сайту <a href="https://hadal.tech">https://hadal.tech</a> и программному обеспечению «Цифровой двойник сети Hadal», предоставляемому обществом с ограниченной ответственностью «ДИПСИ НЕТВОРКС» (ИНН 5047303338), далее – «Поставщик».
              </p>
              <p>
                Настоящее Соглашение регулирует отношения между Поставщиком и Заказчиком (Пользователем ПО).
              </p>
              <p>
                Поставщик оставляет за собой право в любое время изменять, добавлять или удалять пункты настоящего Соглашения без уведомления Пользователя.
              </p>
              <p>
                Продолжение использования ПО Пользователем означает принятие Соглашения и изменений, внесенных в настоящее Соглашение.
              </p>
              <p>
                Пользователь несет персональную ответственность за проверку настоящего Соглашения на наличие изменений в нем.
              </p>
            </section>

            <section>
              <h2>1. Термины и определения</h2>
              <p>1.1. Программное обеспечение (ПО) – программное обеспечение «Цифровой двойник сети Hadal», предназначенное для автоматического документирования, постоянного контроля и анализа изменений конфигураций и операционного состояния сетевого оборудования, находящегося в корпоративной сети передачи данных предприятий.</p>
              <p>1.2. Лицензия – право использования ПО в соответствии с условиями, определенными в лицензионном соглашении и настоящем Соглашении.</p>
              <p>1.3. Срок действия лицензии – период времени, в течение которого Заказчик имеет право использовать ПО в соответствии с условиями лицензионного соглашения.</p>
              <p>1.4. Техническая поддержка – комплекс услуг по консультированию и содействию в решении технических вопросов, связанных с использованием ПО.</p>
              <p>1.5. Сайт – веб-сайт Поставщика <a href="https://hadal.tech">https://hadal.tech</a>.</p>
              <p>1.6. On-premise решение – программное обеспечение, устанавливаемое и функционирующее на оборудовании Заказчика.</p>
            </section>

            <section>
              <h2>2. Общие положения</h2>
              <p>2.1. Настоящее Соглашение устанавливает единые правила и требования, которые Заказчик обязан соблюдать при использовании ПО Поставщика.</p>
              <p>2.2. Все услуги предоставляются Поставщиком только при условии наличия технической возможности их предоставления.</p>
              <p>2.3. Поставщик предоставляет Заказчику:</p>
              <ul>
                <li>Лицензию на использование ПО «Цифровой двойник сети Hadal»</li>
                <li>Услуги технической поддержки</li>
                <li>Услуги по установке и настройке ПО</li>
                <li>Услуги по обучению работе с ПО</li>
                <li>Иные услуги, указанные на сайте <a href="https://hadal.tech">https://hadal.tech</a></li>
              </ul>
              <p>2.4. ПО предназначено для:</p>
              <ul>
                <li>Автоматического сбора данных о конфигурациях и операционном состоянии сетевого оборудования через защищенные протоколы (SSH, Telnet, API и др.)</li>
                <li>Построения многоуровневых карт сетевой инфраструктуры</li>
                <li>Исторического анализа состояний оборудования в сетевой инфраструктуре</li>
                <li>Валидации и верификации сетевой инфраструктуры</li>
              </ul>
            </section>

            <section>
              <h2>3. Приобретение и установка ПО</h2>
              <p>3.1. Заказ ПО осуществляется через сайт <a href="https://hadal.tech">https://hadal.tech</a> или по электронной почте <a href="mailto:info@hadal.tech">info@hadal.tech</a>.</p>
              <p>3.2. После оформления заказа Поставщик направляет Заказчику коммерческое предложение и проект договора.</p>
              <p>3.3. Поставка ПО осуществляется после подписания договора и поступления оплаты на расчетный счет Поставщика.</p>
              <p>3.4. Установка ПО производится на оборудовании Заказчика специалистами Поставщика или самостоятельно Заказчиком в соответствии с предоставленной документацией.</p>
              <p>3.5. Заказчик обеспечивает необходимые технические условия для установки и функционирования ПО.</p>
            </section>

            <section>
              <h2>4. Использование ПО</h2>
              <p>4.1. Заказчик получает право использования ПО в соответствии с условиями лицензионного соглашения.</p>
              <p>4.2. ПО устанавливается и функционирует на оборудовании Заказчика (on-premise решение).</p>
              <p>4.3. Заказчик несет ответственность за обеспечение безопасности и сохранности ПО и данных, обрабатываемых с его помощью.</p>
              <p>4.4. Поставщик предоставляет техническую поддержку в течение срока действия лицензии.</p>
            </section>

            <section>
              <h2>5. Оплата услуг</h2>
              <p>5.1. Стоимость ПО и услуг определяется в соответствии с действующим прайс-листом Поставщика.</p>
              <p>5.2. Оплата производится в соответствии с условиями заключенного договора.</p>
              <p>5.3. Все расчеты между Поставщиком и Заказчиком производятся в рублях Российской Федерации.</p>
            </section>

            <section>
              <h2>6. Возврат денежных средств</h2>
              <p>6.1. Возврат денежных средств производится в соответствии с условиями заключенного договора.</p>
              <p>6.2. В случае отказа Заказчика от услуг до начала их оказания возврат денежных средств производится в полном объеме.</p>
              <p>6.3. В случае отказа Заказчика от услуг после начала их оказания возврат денежных средств производится за вычетом стоимости фактически оказанных услуг.</p>
            </section>

            <section>
              <h2>7. Ответственность</h2>
              <p>7.1. Заказчик использует ПО на свой собственный страх и риск. Поставщик не несет ответственности за какой-либо ущерб, который может быть нанесен оборудованию и/или данным вследствие использования ПО.</p>
              <p>7.2. Поставщик не несет ответственности за прямой или косвенный ущерб, причиненный Заказчику в результате использования или невозможности использования ПО.</p>
              <p>7.3. Поставщик не несет ответственности за качество каналов связи и сетевого оборудования Заказчика.</p>
              <p>7.4. Поставщик не гарантирует абсолютную бесперебойность работы ПО и обязуется принимать разумные меры для обеспечения его стабильного функционирования.</p>
              <p>7.5. Поставщик не несет ответственности за действия третьих лиц и за любые договоры между Заказчиком и третьими лицами.</p>
            </section>

            <section>
              <h2>8. Обязательства Заказчика</h2>
              <p>8.1. Заказчик обязуется:</p>
              <ul>
                <li>Предоставлять по запросу Поставщика информацию, необходимую для оказания услуг</li>
                <li>Соблюдать условия лицензионного соглашения</li>
                <li>Не предпринимать действий, которые могут нарушить нормальную работу ПО</li>
                <li>Обеспечивать сохранность и конфиденциальность данных, обрабатываемых с помощью ПО</li>
                <li>Не использовать ПО в незаконных целях</li>
              </ul>
              <p>8.2. Заказчику запрещается:</p>
              <ul>
                <li>Распространять ПО без согласия Поставщика</li>
                <li>Осуществлять обратную разработку ПО</li>
                <li>Модифицировать ПО без согласия Поставщика</li>
                <li>Использовать ПО для нарушения прав третьих лиц</li>
              </ul>
            </section>

            <section>
              <h2>9. Нарушение условий соглашения</h2>
              <p>9.1. При нарушении Заказчиком условий настоящего Соглашения Поставщик вправе прекратить предоставление услуг и расторгнуть договор в одностороннем порядке.</p>
              <p>9.2. Поставщик имеет право требовать от Заказчика возмещения причиненного ущерба.</p>
            </section>

            <section>
              <h2>10. Дополнительные условия</h2>
              <p>10.1. Поставщик не принимает встречные предложения от Заказчика относительно изменений настоящего Соглашения.</p>
              <p>10.2. Все споры разрешаются в соответствии с законодательством Российской Федерации.</p>
              <p>10.3. Настоящее Соглашение действует до его изменения или отмены Поставщиком.</p>
              <p>10.4. Актуальная версия Пользовательского соглашения в свободном доступе расположена в сети Интернет по адресу <a href="https://hadal.tech/legal/user-agreement">https://hadal.tech/legal/user-agreement</a>.</p>
            </section>
          </div>
        </div>
      </div>
      
      <div id="footer">
        <div className="container text-center">
          <p>
            &copy; 2025 Hadal Project, All Rights Reserved
          </p>
        </div>
      </div>
    </div>
  );
};

export default UserAgreement; 